<template lang="pug">
    main#main
      slot
</template>

<script>
export default {
  name: 'MainComponent'
}
</script>

<style scoped lang="stylus">
@import '../css/vars'

#main
  overflow hidden
  margin-top 11rem
  height calc(calc(var(--vh, 1vh) * 100) - 14rem)

  @media screen and (max-width: $media-query-width-laptop)
    margin-top 8rem
    height calc(calc(var(--vh, 1vh) * 100) - 11rem)

  @media screen and (max-width: $media-query-width-tablet)
    height calc(calc(var(--vh, 1vh) * 100) - 10rem)
</style>



// WEBPACK FOOTER //
// src/components/MainComponent.vue